import React from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';

import { Row, Col, Menu } from 'antd';
import Link from 'next/link';
import LanguageSwitcher from './LanguageSwitcher';
import { ROUTE_OPENING_REQUEST } from '../../shared/variables/routes';

export default function TopMenu() {
  const router = useRouter();
  const current = `/${router?.pathname.split('/')[1]}`;
  const { t } = useTranslation();

  const TOP_MENU = [
    {
      text: t('topMenu.addLeague'),
      url: ROUTE_OPENING_REQUEST,
      active: true,
      target: '_self',
    },
    {
      text: t('topMenu.pricing'),
      url: '/ucretlendirme',
      active: true,
      target: '_self',
    },
    {
      text: t('topMenu.howToJoin'),
      url: '/akademi/nasil-uye-olurum',
      active: true,
      target: '_self',
    },
    {
      text: t('topMenu.matchPlaying'),
      url: '/akademi/mac-oynama-sureci',
      active: true,
      target: '_self',
    },
    {
      text: t('topMenu.prizes'),
      url: '/oduller',
      active: true,
      target: '_self',
    },
    {
      text: t('topMenu.help'),
      url: '/yardim',
      active: true,
      target: '_self',
    },
  ];

  return (
    <Row>
      <Col span={24}>
        <div className="header-top-menu">
          <Menu mode="horizontal" selectedKeys={[current]}>
            {TOP_MENU.filter(item => item.active).map(item => (
              <Menu.Item key={item.url}>
                <Link href={item.url}>
                  <a target={item.target}>{item.text}</a>
                </Link>
              </Menu.Item>
            ))}
          </Menu>
          <LanguageSwitcher />
        </div>
      </Col>
    </Row>
  );
}
